export default __webpack_public_path__ + "static/media/info.6336870a.svg";